import { GuardedType, isString } from "generic-type-guard";

import { createDescriptorFunctions } from "@de.skhh.modulf/client-core";

/** Controls how selected contacts are written back to the initiating activity's document.
 * - `undefined` / `"empfaenger"` (default): writes `{ empfaenger, empfaengerTyp }` — used for Prozess_WF email recipient fields.
 * - `"email"`: writes `{ email }` — used for invitation recipient fields.
 */
const isContactEntryMode = (v: unknown): v is string | undefined =>
	v === undefined || v === null || v === "empfaenger" || v === "email";

/** Comma-separated list of client identifiers to filter contacts by. Empty string means null-client. */
const isOptionalString = (v: unknown): v is string | undefined =>
	v === undefined || v === null || typeof v === "string";

export const ContactSelectionModalDescriptor = createDescriptorFunctions(
	{
		modal: "ContactSelectionModal",
		model: "contactListSelection_T"
	} as const,
	{
		sourceAppKeys: isString,
		sourceActivityId: isString,
		targetGroupPath: isString,
		entryMode: isContactEntryMode,
		clients: isOptionalString
	}
);

export type ContactSelectionModalDescriptor = GuardedType<typeof ContactSelectionModalDescriptor.isInstance>;
